import discounts from '@/store/modules/campaigns/discounts'

const modules = {
  discounts
}

export default {
  namespaced: true,
  modules
}
